window._wp.appContainer = document.getElementById("app") ?? document.body;
window._wp.overlayContainer =
  document.getElementById("overlays") ?? document.body;

export {};
